"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banks = void 0;
var react_1 = __importDefault(require("react"));
var Banks_module_scss_1 = __importDefault(require("./Banks.module.scss"));
var BanksList_1 = require("../../components/banksList/BanksList");
var BreadCrumpPage_1 = require("../../components/breadCrumpPage/BreadCrumpPage");
var Banks = function () {
    return (react_1.default.createElement("div", { className: "container" },
        react_1.default.createElement("div", { className: Banks_module_scss_1.default.banks },
            react_1.default.createElement(BreadCrumpPage_1.BreadCrumpPage, { links: [
                    { name: 'Главная', url: '/' },
                    { name: 'Банки-партнеры', url: '/banks' },
                ] }),
            react_1.default.createElement("h1", { className: Banks_module_scss_1.default.banks__title }, "\u0411\u0430\u043D\u043A\u0438-\u043F\u0430\u0440\u0442\u043D\u0435\u0440\u044B"),
            react_1.default.createElement(BanksList_1.BanksList, null))));
};
exports.Banks = Banks;
